export default __webpack_public_path__ + "static/img-swordfish-500x325-84c956e270e8870dc9d3d46c1fe61827.png";